// extracted by mini-css-extract-plugin
module.exports = {"graphPrimary":"#e87722","graphSecondary":"#fae4d3"};